import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { AiFillEye } from "react-icons/ai";
import { BsThreeDots } from "react-icons/bs";
import { FiEdit, FiSearch, FiTrash } from "react-icons/fi";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../../Context/AuthContext";
import { useTabList } from "../../Context/TabListContext";
import {
  formatNewDateString,
  showToastError,
  showToastSuccess,
  sortArrLatest,
} from "../../Utils/Helper";
import DeleteModal from "../../commonComponent/DeleteModal";
import Loader from "../../commonComponent/Loader";
import { getCareplanShareLink } from "../../services/ActivePrograms";
import {
  addArchiveCareplan,
  addDuplicateCareplan,
  assignGroupToCarePlanService,
  createCarePlanService,
  deleteCareplan,
  getAllCarePlanListService,
  getDefaultPlanList,
  setDefaultCarePlan,
  updateCarePlanService,
} from "../../services/CreateCarePlanService";
import Navbar from "../header/Navbar";
import Sidebar from "../sidebar/Sidebar";
import AssignToClients from "./AssignToClientsModal";
import AssignToGroups from "./AssignToGroupsModal";
import ShareLinkModal from "./ShareLinkModal";
import AddCarePlanDescription from "./carePlanTemplates/AddCarePlanDescription";
import "./style.css";

const CarePlan_ = () => {
  const navigate = useNavigate();
  const [isLoading, setLoader] = useState(true);
  const { userId } = useParams();
  const { isAdmin } = useAuth();
  // const newCreatedPlanId = state?.newCreatedPlanId; // To Check whether new program is created or not if yes then directly navigate to Active program tab screen module
  const [carePlanList, setCarePlanList] = useState([]);
  const [filterdata, setFilterData] = useState([]);
  const [careGroups, setCareGroups] = useState([]);
  const [careClients, setCareClients] = useState([]);
  const [selectedCarePlan, setSelectedCarePlan] = useState("");
  const [listTabs, setListTabs] = useState({
    active: true,
    archived: false,
    default: false,
  });
  const [linkInput, setLinkInput] = useState("");
  const { careplanTabList, setCareplanTabList } = useTabList();

  // useEffect(() => {
  //   getCarePlanList();
  //   if (tab === "default") {
  //     setListTabs((prev) => {
  //       return { prev, default: true };
  //     });
  //     getDefaultCarePlanList();
  //   }
  // }, []);

  useEffect(() => {
    console.log(careplanTabList)
    if (careplanTabList === "default") {
      setListTabs((prev) => {
        return { prev, default: true };
      });
      getDefaultCarePlanList();
    } else {
      setListTabs((prev) => {
        return { prev, active: true };
      });      
      getCarePlanList();
    }
    setCareplanTabList("");
  }, []);

  let defaultCarePlanDetail = {
    name: "fitness new care plan",
    description: "for healthy purpose",
    image: "",
    assignDate: "2023-09-16",
    duration: 15,
  };
  const makeDefault = async (careplanId) => {
    try {
      const response = await setDefaultCarePlan(careplanId);
      if (response.status === 200) {
        // document.getElementById("checkbox").checked = true;
        showToastSuccess(`Action completed successfully`);
        getCarePlanList();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (userId && carePlanList.length) {
      const result = carePlanList.filter((value) => value._id === userId);
      if (result.length) {
        setSelectedCarePlan(result[0]);
        navigate(`/careplan/${result[0]._id}`, { replace: true });
      } else {
        if (carePlanList?.length) {
          setSelectedCarePlan(carePlanList[0]);
        }
        // showToastError(toastMsg.programNotAvailable)
      }
    } // eslint-disable-next-line
  }, [userId, carePlanList]);
  const updateMembers = async () => {
    setLoader(true);
    // console.log(careClients, "clients", selectedCarePlan)
    try {
      const response = await updateCarePlanService(selectedCarePlan._id, {
        ...selectedCarePlan,
        clients: careClients,
      });
      if (response) {
        showToastSuccess("Members Assigned Successfully");
        // getCarePlanList();
        // props.onRefresh()
        setCareClients([]);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  const updateGroups = async () => {
    setLoader(true);
    // console.log(careGroups, "clients", selectedCarePlan)
    try {
      const response = await updateCarePlanService(selectedCarePlan._id, {
        ...selectedCarePlan,
        groups: careGroups,
      });
      if (response) {
        try {
          const response = await assignGroupToCarePlanService({
            careplanId: [selectedCarePlan._id],
            groupId: careGroups,
          });
          if (response) {
            showToastSuccess("Groups Assigned Successfully");
            // getCarePlanList();
            // props.onRefresh()
            setCareGroups([]);
          }
          setLoader(false);
        } catch (error) {
          setLoader(false);
          console.log(error);
        }
        // showToastSuccess("Groups Assigned Successfully");
        // getCarePlanList();
        // props.onRefresh()
        setCareGroups([]);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  const getShareLink = async (planId) => {
    try {
      const response = await getCareplanShareLink(planId);
      setLoader(false);

      if (response.status === 200) {
        // console.log(response, "responseData");
        setLinkInput(response?.data);
      } else {
        alert(response?.data || response.message);
      }
    } catch (error) {
      setLoader(false);
      error?.data?.data && alert(error?.data?.data || error.data?.message);
    }
  };

  // delete Careplan

  const deleteCareplans = async (careId) => {
    try {
      const response = await deleteCareplan(careId);
      if (response.status === 200) {
        showToastSuccess(`Careplan deleted successfully`);
        getCarePlanList();
        setFilterData(
          filterdata.filter((item) => {
            return item.isArchive;
          })
        );
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  // duplicate careplan

  const duplicateCareplan = async (careId) => {
    let payload = {
      carePlanId: careId,
    };
    try {
      const response = await addDuplicateCareplan(payload);
      if (response.status === 200) {
        showToastSuccess(`Careplan copied successfully`);
        getCarePlanList();
        setFilterData(
          filterdata.filter((item) => {
            return item.isArchive;
          })
        );
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  // To get All active program list
  const getCarePlanList = async () => {
    setLoader(true);
    setFilterData([]);
    try {
      const response = await getAllCarePlanListService();
      setLoader(false);
      if (response.status === 200) {
        setCarePlanList(response?.data);
        if (response.data?.length > 0)
          setFilterData(sortArrLatest(response?.data));
      }
    } catch (error) {
      setLoader(false);
    }
  };
  // To get All default program list
  const getDefaultCarePlanList = async () => {
    setLoader(true);
    setFilterData([]);
    try {
      const response = await getDefaultPlanList();
      setLoader(false);
      if (response.status === 200) {
        setCarePlanList(response?.data?.data);
        if (response.data.data?.length > 0)
          setFilterData(sortArrLatest(response?.data?.data));
        console.log(response?.data, "response default");
      }
    } catch (error) {
      setLoader(false);
    }
  };
  const AddCarePlan = async () => {
    try {
      const response = await createCarePlanService({ defaultCarePlanDetail });
      if (response.status === 200) {
        console.log(response.data, "create Response");
        navigate("/AddEditCarePlan", {
          state: { componentType: "Add", careplan: response.data },
        });
        // careplan
        // showToast(toastMsg.createCarePlans)
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const onChangeSearchText = async (e) => {
    let searchWord = e.target.value;
    const result = carePlanList?.filter((value) => {
      if (value) {
        return value?.name?.toLowerCase()?.includes(searchWord?.toLowerCase());
      } else {
        return [];
      }
    });

    if (searchWord === "") {
      setFilterData(carePlanList);
      // getForumsById(searchWord);
    } else {
      setFilterData(result);
    }
  };
  const renderLoader = () => {
    return (
      <Loader
        visible={isLoading}
        emptyTextKey={"noAnyCarePlan"}
        style={{ top: 0, position: "relative" }}
      />
    );
  };
  const renderArchivedLoader = () => {
    return (
      <Loader
        visible={isLoading}
        emptyTextKey={"noAnyCarePlan"}
        style={{ top: 0, position: "relative" }}
      />
    );
  };

  const addArchive = async (careplanId) => {
    setLoader(true);
    let parms = {
      Id: careplanId,
      Type: "careplan",
    };

    try {
      const response = await addArchiveCareplan(parms);
      setLoader(false);
      if (!response?.data?.status === 200) {
        toast.error(`status:${response?.data?.status}`);
      }
      if (response?.data?.data?.isArchive === false) {
        showToastSuccess(`Care plan Unarchived`);
      } else {
        showToastSuccess(`Care plan Archived`);
      }

      getCarePlanList();
    } catch (response) {
      toast.error(response?.data?.data);
    }
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  const debouncedAddArchive = debounce(addArchive, 1000);

  const addtoActive = async (careplanId) => {
    //We Will implement this function once API is created
    try {
      if (careplanId) {
        console.log("careplanId", careplanId);
        const response = await addArchiveCareplan(careplanId);
        if (!response.data.status === 200) {
          toast.error(`status:${response.data.status}`);
        }
        if (response.data.data?.length > 0)
          setFilterData(sortArrLatest(response?.data?.data));
        showToastSuccess(`Action completed successfully`);
        getCarePlanList();
      } else {
        toast.error("Careplan Id is not available");
      }
    } catch (response) {
      toast.error(response.data.data);
    }
  };

  const renderSearchHeader = () => {
    return (
      <div className="col-md-12 d-flex">
        <div className="w-50 ">
          <h4 className="chidHeadFont">Care Plans</h4>
          <p className="resFont">View your care plan line ups</p>
        </div>
        <div className="w-50 d-flex">
          {/* <div className="actsearch_simple me-2">
            <FiSearch className="boxicon" />
            <input
              placeholder="Search for care plans..."
              className="ms-2"
              onChange={(e) => onChangeSearchText(e)}
            />
          </div> */}
          {/* <button
            onBlur={() => { setDropDownList(false) }}
            onClick={() => { setDropDownList(!dropDownList); setDropDown(false) }}
            className="btn btn-primary btn-custom position-relative dropdown-toggle"
            type="button"
          >
            Filters
            <ul className={menuClass + " top-0 start-0 w-100"} style={{marginTop: '3.5em'}}>
                <li><a className="dropdown-item pointer" onClick={() => { nameSort(filterdata) }}>Alphabetical Order</a></li>
                <li><a className="dropdown-item pointer" onClick={() => { dateSort(filterdata); }
                }>Date Order</a></li>
              </ul>
          </button> */}
          {/* <p
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Add Care Plan"
            className="btn btn-primary btn-custom ms-2"
            onClick={AddCarePlan}
          >
            <AiOutlinePlus className="me-2" /> Add Care Plan
          </p> */}
        </div>
      </div>
    );
  };
  const renderList = () => {
    if (listTabs.active)
      return (
        <tbody>
          {filterdata?.map((item) => {
            if (!item.isArchive) {
              return (
                <tr
                  key={item._id}
                  className="pointer"
                  onClick={() => {
                      navigate("/careplanedit", {
                        state: { careplan: item, isFromDefault: false },
                      });
                  }}
                >
                  <td
                    className="text-muted"
                    // onClick={() =>
                    //   navigate("/careplaninfo", { state: { careplan: item } })
                    // }
                  >{`${item.name}`}</td>
                  <td
                    className="text-muted"
                    // onClick={() =>
                    //   navigate("/careplaninfo", { state: { careplan: item } })
                    // }
                  >{`${item.description}`}</td>
                  <td
                    className="text-muted"
                    // onClick={() =>
                    //   navigate("/careplaninfo", { state: { careplan: item } })
                    // }
                  >
                    {formatNewDateString(item.assignDate)}
                  </td>
                  <td
                    className="text-muted"
                    // onClick={() =>
                    //   navigate("/careplaninfo", { state: { careplan: item } })
                    // }
                  >
                    {item.duration} days
                  </td>
                  <td
                    className="text-muted fw-bold text-left overflow-visible"
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex gap-1">
                      {/* <GroupActivityButton className='bg-light border-0 custom rounded px-3'fontWeight='semibold' ><FiEye/></GroupActivityButton> */}
                      <button
                        onClick={() => {
                            navigate("/careplanedit", {
                              state: { careplan: item, isFromDefault: false },
                            });
                        }}
                        className="btn btn-light"
                      >
                        <AiFillEye className="mb-1" />
                      </button>
                      <button
                        onClick={(e) => {
                          navigate("/careplanedit", {
                            state: { careplan: item, isFromDefault: false },
                          });
                          e.stopPropagation();
                        }}
                        className="btn btn-light"
                      >
                        <FiEdit className="mb-1" />
                      </button>
                      <button
                        className="btn btn-light"
                        onClick={(e) => {
                          e.stopPropagation();
                          debouncedAddArchive(item._id);
                        }}
                      >
                        <FiTrash className="mb-1" />
                      </button>

                      <Dropdown onClick={(e) => e.stopPropagation()}>
                        <Dropdown.Toggle
                          variant="light"
                          className="custom"
                          id="dropdown-basic"
                        >
                          <BsThreeDots className="icon mb-1" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {/* <Dropdown.Item
                            onClick={() => {
                              navigate("/careplanedit", {
                                state: { careplan: item },
                              });
                            }}
                          >
                            View
                          </Dropdown.Item> */}
                          <Dropdown.Item
                            data-bs-toggle="modal"
                            data-bs-target="#assignclientsmodal1"
                            onClick={() => {
                              setSelectedCarePlan(item);
                              setCareClients(item.clients);
                            }}
                          >
                            Assign to members
                          </Dropdown.Item>
                          <Dropdown.Item
                            data-bs-toggle="modal"
                            data-bs-target="#assigngroupsmodal1"
                            onClick={() => {
                              setSelectedCarePlan(item);
                              setCareGroups(
                                item.groups.map((dt) => {
                                  return dt._id;
                                })
                              );
                            }}
                          >
                            Assign to groups
                          </Dropdown.Item>
                          {/* <Dropdown.Item
                            onClick={() => {
                              navigate("/careplanedit", {
                                state: { careplan: item },
                              });
                            }}
                          >
                            Edit
                          </Dropdown.Item> */}
                          {isAdmin ? (
                            <Dropdown.Item
                              href="#/action-2"
                              onClick={() => makeDefault(item._id)}
                            >
                              {item.autoPlan === true
                                ? "Remove as Default"
                                : "Make Default"}
                            </Dropdown.Item>
                          ) : null}
                          <Dropdown.Item
                            href="#/action-3"
                            data-bs-toggle="modal"
                            data-bs-target="#shareModal"
                            onClick={() => getShareLink(item._id)}
                          >
                            Share Link
                          </Dropdown.Item>
                          <Dropdown.Item
                            href="#/action-3"
                            onClick={() => duplicateCareplan(item._id)}
                          >
                            Copy care plan
                          </Dropdown.Item>
                          {/* <Dropdown.Item
                            onClick={() => {
                              navigate("/plantemplate", {
                                state: { careplan: item },
                              });
                            }}
                          >
                            Use as Template
                          </Dropdown.Item> */}
                          {/* <Dropdown.Item onClick={() => navigate("/careplaninfo", { state: { careplan: item } })}>View</Dropdown.Item>
                          <Dropdown.Item onClick={() => { navigate("/editplan", { state: { careplan: item } }) }}>Edit</Dropdown.Item> */}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </td>
                </tr>
              );
            } else {
              return null;
            }
          })}
        </tbody>
      );

    if (listTabs.default)
      return (
        <tbody>
          {filterdata?.map((item) => {
            if (item.autoPlan && !item.isArchive) {
              return (
                <tr
                  onClick={() =>
                    navigate("/careplanedit", {
                      state: { careplan: item, isFromDefault: true },
                    })
                  }
                >
                  <td
                    className="text-muted"
                  >{`${item.name}`}</td>
                  <td
                    className="text-muted"
                  >{`${item.description}`}</td>
                  <td
                    className="text-muted"
                  >
                    {formatNewDateString(item.assignDate)}
                  </td>
                  <td
                    className="text-muted"
                  >
                    {item.duration} days
                  </td>
                  <td
                    className="text-muted fw-bold text-left overflow-visible"
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex gap-1">
                      <button
                        onClick={(e) => {
                          navigate("/careplanedit", {
                            state: { careplan: item, isFromDefault: true },
                          })
                          e.stopPropagation();
                        }}
                        className="btn btn-light"
                      >
                        <AiFillEye className="mb-1" />
                      </button>
                      <button
                        onClick={(e) => {
                          navigate("/careplanedit", {
                            state: { careplan: item, isFromDefault: true },
                          })
                          e.stopPropagation();
                        }}
                        className="btn btn-light"
                      >
                        <FiEdit className="mb-1" />
                      </button>
                      <button
                        className="btn btn-light"
                        onClick={(e) => {
                          e.stopPropagation();
                          debouncedAddArchive(item._id);
                        }}
                      >
                        <FiTrash className="mb-1" />
                      </button>

                      <Dropdown onClick={(e) => e.stopPropagation()}>
                        <Dropdown.Toggle
                          variant="light"
                          className="custom"
                          id="dropdown-basic"
                        >
                          <BsThreeDots className="icon" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {/* <Dropdown.Item
                            onClick={() =>
                              navigate("/careplaninfo", {
                                state: { careplan: item },
                              })
                            }
                          >
                            View
                          </Dropdown.Item> */}
                          <Dropdown.Item
                            data-bs-toggle="modal"
                            data-bs-target="#assignclientsmodal1"
                            onClick={() => {
                              navigate("/careplanedit", {
                                state: { careplan: item },
                              });
                            }}
                          >
                            Assign to members
                          </Dropdown.Item>
                          <Dropdown.Item
                            data-bs-toggle="modal"
                            data-bs-target="#assigngroupsmodal1"
                            onClick={() => {
                              setSelectedCarePlan(item);
                              setCareGroups(
                                item.groups.map((dt) => {
                                  return dt._id;
                                })
                              );
                            }}
                          >
                            Assign to groups
                          </Dropdown.Item>
                          {/* <Dropdown.Item
                            onClick={() => {
                              navigate("/careplanedit", {
                                state: { careplan: item },
                              });
                            }}
                          >
                            Edit
                          </Dropdown.Item> */}
                          {isAdmin ? (
                            <Dropdown.Item
                              href="#/action-2"
                              onClick={() => makeDefault(item._id)}
                            >
                              {item.autoPlan === true
                                ? "Remove as Default"
                                : "Make Default"}
                            </Dropdown.Item>
                          ) : null}
                          <Dropdown.Item
                            href="#/action-3"
                            data-bs-toggle="modal"
                            data-bs-target="#shareModal"
                            onClick={() => getShareLink(item._id)}
                          >
                            Share Link
                          </Dropdown.Item>
                          {/* <Dropdown.Item
                            onClick={(e) => {
                              navigate("/plantemplate", {
                                state: { careplan: item },
                              });
                            }}
                          >
                            Use as Template
                          </Dropdown.Item> */}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </td>
                </tr>
              );
            } else {
              return null;
            }
          })}
        </tbody>
      );

    if (listTabs.archived)
      return (
        <tbody>
          {filterdata?.map((item) => {
            console.log(item.name);
            if (item.isArchive) {
              return (
                <tr
                  onClick={() =>
                    navigate("/careplanedit", {
                      state: { careplan: item, isFromDefault: false },
                    })   
}
                >
                  <td
                    className="text-muted"
                  >{`${item.name}`}</td>
                  <td
                    className="text-muted"
                  >{`${item.description}`}</td>
                  <td
                    className="text-muted"
                  >
                    {formatNewDateString(item.assignDate)}
                  </td>
                  <td
                    className="text-muted"
                  >
                    {item.duration} days
                  </td>
                  <td
                    className="text-muted fw-bold text-left overflow-visible"
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex gap-1">
                      <button
                        onClick={(e) => {
                          navigate("/careplanedit", {
                            state: { careplan: item, isFromDefault: false },
                          });   
                          e.stopPropagation();
                        }}
                        className="btn btn-light"
                      >
                        <AiFillEye className="mb-1" />
                      </button>
                      <button
                        onClick={(e) => {
                          navigate("/careplanedit", {
                            state: { careplan: item, isFromDefault: false },
                          });   
                          e.stopPropagation();
                        }}
                        className="btn btn-light"
                      >
                        <FiEdit className="mb-1" />
                      </button>
                      <button
                        data-bs-toggle={item.isArchive ? "modal" : ""}
                        data-bs-target={
                          item.isArchive ? "#careplan" + item._id : ""
                        }
                        className="btn btn-light"
                        onClick={(e) => {
                          e.stopPropagation();
                          // deleteCareplans(item._id);
                        }}
                      >
                        <FiTrash className="mb-1" />
                      </button>

                      <Dropdown onClick={(e) => e.stopPropagation()}>
                        <Dropdown.Toggle
                          variant="light"
                          className="custom"
                          id="dropdown-basic"
                        >
                          <BsThreeDots className="icon" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {/* <Dropdown.Item
                          onClick={(e) => {
                            navigate("/careplanedit", {
                              state: { careplan: item },
                            });
                            e.stopPropagation()
                          }}
                        >
                          View
                        </Dropdown.Item> */}
                          <Dropdown.Item
                            data-bs-toggle="modal"
                            data-bs-target="#assignclientsmodal1"
                            onClick={() => {
                              setSelectedCarePlan(item);
                              setCareClients(item.clients);
                            }}
                          >
                            Assign to members
                          </Dropdown.Item>
                          <Dropdown.Item
                            data-bs-toggle="modal"
                            data-bs-target="#assigngroupsmodal1"
                            onClick={() => {
                              setSelectedCarePlan(item);
                              setCareGroups(
                                item.groups.map((dt) => {
                                  return dt._id;
                                })
                              );
                            }}
                          >
                            Assign to groups
                          </Dropdown.Item>
                          {/* <Dropdown.Item
                          onClick={() => {
                            navigate("/careplanedit", {
                              state: { careplan: item },
                            });
                          }}
                        >
                          Edit
                        </Dropdown.Item> */}
                          {isAdmin ? (
                            <Dropdown.Item
                              href="#/action-2"
                              onClick={() => makeDefault(item._id)}
                            >
                              {item.autoPlan === true
                                ? "Remove as Default"
                                : "Make Default"}
                            </Dropdown.Item>
                          ) : null}
                          <Dropdown.Item
                            href="#/action-3"
                            data-bs-toggle="modal"
                            data-bs-target="#shareModal"
                            onClick={() => getShareLink(item._id)}
                          >
                            Share Link
                          </Dropdown.Item>
                          {item.isArchive === true ? (
                            <Dropdown.Item
                              href="#/action-6"
                              onClick={() => {
                                console.log("UnArchived");
                                addArchive(item._id);
                              }}
                            >
                              Unarchive
                            </Dropdown.Item>
                          ) : null}
                          {/* <Dropdown.Item
                          onClick={() => {
                            navigate("/plantemplate", {
                              state: { careplan: item },
                            });
                          }}
                        >
                          Use as Template
                        </Dropdown.Item> */}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <DeleteModal
                      onCancel={(e) => {
                        e.stopPropagation();
                      }}
                      button1={"Delete"}
                      content1={"Are you sure?"}
                      content2={"You want to delete This Care plan"}
                      modalId={`careplan${item._id}`}
                      key={item._id}
                      title={"Delete"}
                      button2={"cancel"}
                      onDelete={(e) => {
                        e.stopPropagation();
                        deleteCareplans(item._id);
                      }}
                    />
                  </td>
                </tr>
              );
            } else {
              return null;
            }
          })}
        </tbody>
      );
  };

  return (
    <>
      <Navbar />
      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-md-2">
            <Sidebar />
          </div>

          <div className="col-md-10 py-4 px-5">
            {/* <p className="dashboard_title">
              <HiOutlineArrowSmLeft
                onClick={() => navigate('/')}
                className="icon"
              />
              care plans
            </p> */}
            {/* <div className="container"> */}
            <div className="col-md-12 d-flex justify-content-between align-items-center">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li
                    class="breadcrumb-item cursor-pointer"
                    onClick={() => navigate("/")}
                  >
                    Home
                  </li>
                  <li
                    class="breadcrumb-item active fw-bold"
                    aria-current="page"
                  >
                    Care Plans
                  </li>
                </ol>
              </nav>
              <AddCarePlanDescription getCarePlanList={getCarePlanList} />
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="mt-2 px-2" style={{ height: "486px" }}>
                  {renderSearchHeader()}
                  <div className="mt-2 pb-2">
                    <div
                      className="custom-tabs border-bottom d-flex"
                      style={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <b
                          onClick={() => {
                            setListTabs((prev) => {
                              return { prev, active: true };
                            });
                            getCarePlanList();
                          }}
                          className={`px-3 border-bottom py-3 tab mb-0  ${
                            listTabs.active && "active"
                          }`}
                        >
                          My Careplans
                        </b>
                        <b
                          onClick={() => {
                            setListTabs((prev) => {
                              return { prev, default: true };
                            });
                            getDefaultCarePlanList();
                          }}
                          className={`px-3 border-bottom py-3 tab mb-0  ${
                            listTabs.default && "active"
                          }`}
                        >
                          Default
                        </b>
                        <b
                          onClick={() => {
                            setListTabs((prev) => {
                              return { prev, archived: true };
                            });
                            getCarePlanList();
                          }}
                          className={`px-3 border-bottom py-3 tab mb-0  ${
                            listTabs.archived && "active"
                          }`}
                        >
                          Archived
                        </b>
                      </div>
                      <div>
                        {/* <button
                          className="btn btn-primary btn-custom-tag position-relative dropdown-toggle tag_btn"
                          type="button"
                        >
                          {" "}
                          <span
                            style={{ color: "#d5bfbf", marginRight: "5px" }}
                          >
                            Tags:
                          </span>{" "}
                          Bood Pressure{" "}
                        </button> */}
                        <div className="actsearch_simple me-2 mb-1">
                          <FiSearch className="boxicon" />
                          <input
                            placeholder="Search for care plans..."
                            className="ms-2"
                            onChange={(e) => onChangeSearchText(e)}
                          />
                        </div>
                      </div>
                    </div>
                    {/* Active Tab */}
                    {listTabs.active && (
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <td className="py-4 tab_title">Title</td>
                            <td className="py-4 tab_title">Description</td>
                            <td className="py-4 tab_title">Created At</td>
                            <td className="py-4 tab_title">Duration</td>
                            <td className="py-4 tab_title">Action</td>
                          </tr>
                        </thead>
                        {renderList()}
                      </table>
                    )}
                    {/* default tabs */}
                    {listTabs.default && (
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <td className="py-4 tab_title">Title</td>
                            <td className="py-4 tab_title">Description</td>
                            <td className="py-4 tab_title">Created At</td>
                            <td className="py-4 tab_title">Duration</td>
                            <td className="py-4 tab_title">Action</td>
                          </tr>
                        </thead>
                        {renderList()}
                      </table>
                    )}
                    {/* Archived Tab */}
                    {listTabs.archived && (
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <td className="py-4 tab_title">Title</td>
                            <td className="py-4 tab_title">Description</td>
                            <td className="py-4 tab_title">Created At</td>
                            <td className="py-4 tab_title">Duration</td>
                            <td className="py-4 tab_title">Action</td>
                          </tr>
                        </thead>
                        {renderList()}
                        {/* <tbody>
                          {list?.map((item) => renderListRow(item))}
                        </tbody> */}
                      </table>
                    )}

                    <ShareLinkModal link={linkInput} />

                    <AssignToClients
                      addMember={updateMembers}
                      members={careClients}
                      setMembers={setCareClients}
                    />
                    <AssignToGroups
                      addMember={updateGroups}
                      members={careGroups}
                      setMembers={setCareGroups}
                    />

                    {!filterdata?.length
                      ? listTabs.archived
                        ? renderArchivedLoader()
                        : renderLoader()
                      : null}
                  </div>
                </div>
              </div>
            </div>
            {/* </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default CarePlan_;
